module.exports = __webpack_public_path__ + "img/supermarket.f7b2421b.png";